import { ProcessingStage } from './useProcessingStage';

function pluraliseStatements(count: number): string {
    return `${count} ${count === 1 ? 'statement' : 'statements'}`;
}

/**
 * The line for the window the screen is in.
 *
 * The first two windows quote the batch, because a count is what makes a wait legible while the
 * numbers are still worth reading. The last one does not: by then the member is being told the
 * work continues without them, and a number they are no longer expected to watch adds nothing.
 *
 * `statementCount` is zero in the gap between a transfer landing and the documents appearing,
 * where nothing knows the batch size — so the copy drops the number rather than inventing one.
 */
export default function narrateProgress(stage: ProcessingStage, statementCount: number): string {
    if (stage === 'processing') {
        return 'Processing your statements...';
    }
    const verb = stage === 'uploading' ? 'Uploading' : 'Scanning';
    return statementCount > 0 ? `${verb} ${pluraliseStatements(statementCount)}...` : `${verb} statements...`;
}
